import * as React from "react";
const SvgCreditCard1Alternate = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "credit-card-1-alternate_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M21 3.5H3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3m-18 2h18a1 1 0 0 1 1 1v1a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-1a1 1 0 0 1 1-1m18 13H3a1 1 0 0 1-1-1v-6a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v6a1 1 0 0 1-1 1" }), /* @__PURE__ */ React.createElement("path", { d: "M8 14.5H5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2" }));
export { SvgCreditCard1Alternate as ReactComponent };
